















































import GlobalMixin from "@/shared/mixins/globalMixin";
import { Component, Mixins } from "vue-property-decorator";
import CadastrosMensagensLeads from "./tabs-cadastros/CadastrosMensagensLeads.vue";
import CadastrosCanaisLeads from "./tabs-cadastros/CadastrosCanaisLeads.vue";
import Tooltip from "@/shared/components/tooltip.vue";

@Component({
  components: { CadastrosMensagensLeads, CadastrosCanaisLeads, Tooltip },
})
export default class Cadastros extends Mixins(GlobalMixin) {
  tab = "cadastrosMensagensLeads";

  voltar() {
    this.$router.back();
  }

}
